import React from 'react';

export const BoxShadow = () => (
  <filter id="blur">
    <feGaussianBlur result="blurOut" in="SourceGraphic" stdDeviation="0.5" />
    <feOffset result="offOut" in="blurOut" dx="0" dy="1" />
    <feBlend in="SourceGraphic" in2="offOut" mode="normal" />
  </filter>
);

export default BoxShadow;



// WEBPACK FOOTER //
// ./src/components/BoxShadow.jsx